import React from 'react';
import './PrimarySectionAdditionActionList.scss';

const PrimarySectionAdditionActionList: React.FC = props => {
  return <div className="PrimarySectionAdditionActionList">{props.children}</div>;
};

export default PrimarySectionAdditionActionList;
